// extracted by mini-css-extract-plugin
export default {"row__more":"ShowMore_row__more__x9ZY6 font-xs-regular","popover_list":"ShowMore_popover_list__X4b7z"};